import generatedPalette from './entity-color-palette.generated.json';

export type EntityColor = {
  id: string;
  name: string;
  hex: string;
};

export type EntityColorPalette = {
  version: number;
  colors: EntityColor[];
};

const hexPattern = /^#[0-9A-F]{6}$/;

export function parseEntityColorPalette(value: unknown): EntityColorPalette {
  if (typeof value !== 'object' || value === null) throw new Error('Invalid entity color palette');
  const candidate = value as {version?: unknown; colors?: unknown};
  if (candidate.version !== 1 || !Array.isArray(candidate.colors) || candidate.colors.length !== 60) {
    throw new Error('Invalid entity color palette');
  }
  const colors = candidate.colors.map((item, index) => {
    if (typeof item !== 'object' || item === null) throw new Error('Invalid entity color palette');
    const color = item as {id?: unknown; name?: unknown; hex?: unknown};
    const id = String(index + 1).padStart(2, '0');
    if (color.id !== id || typeof color.name !== 'string' || color.name.length === 0 || typeof color.hex !== 'string' || !hexPattern.test(color.hex)) {
      throw new Error('Invalid entity color palette');
    }
    return {id, name: color.name, hex: color.hex};
  });
  if (new Set(colors.map(color => color.hex)).size !== colors.length) throw new Error('Invalid entity color palette');
  return {version: 1, colors};
}

export const bundledEntityColorPalette = parseEntityColorPalette(generatedPalette);

export function getOnEntityColor(hex: string): '#15151A' | '#FFFFFF' {
  const red = Number.parseInt(hex.slice(1, 3), 16);
  const green = Number.parseInt(hex.slice(3, 5), 16);
  const blue = Number.parseInt(hex.slice(5, 7), 16);
  return (red * 299 + green * 587 + blue * 114) / 1000 >= 150 ? '#15151A' : '#FFFFFF';
}
